import { render, staticRenderFns } from "./JustificativaCartao.vue?vue&type=template&id=1a36492a&scoped=true"
import script from "./JustificativaCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./JustificativaCartao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36492a",
  null
  
)

export default component.exports